import React, { useEffect, useState } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import ModalBase from 'components/Tvendo/Common/ModalBase';
import { wsUpdate } from 'services/WService';
import RegularButton from 'components/CustomButtons/Button';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';

function EditStockModal(props) {
  const { model, setOpen, listStocks } = props;

  const [locked, setLocked] = useState('');
  const [loading, setLoading] = useState(false);

  function handleClose() {
    if (loading) return;
    setOpen({ open: false });
  }

  async function updateStock() {
    setLoading(true);
    let res = await wsUpdate(`logi/stock/${model.id}`, { Locked: locked });
    setLoading(false);
    if (res.success) {
      window.alert(res.message);
      handleClose();
      listStocks();
      return;
    }
    window.alert(res.message);
    setLocked(model.Locked);
  }

  useEffect(() => {
    if (model.id === undefined) return;
    setLocked(model.Locked || '');
  }, [model]);

  return (
    <ModalBase
      model={model}
      setOpen={handleClose}
      title={`${model.ItemCode} ${model.ItemName} ${model.WhsName}`}
      handleCloseDisabled={loading}
      hideSave
      fullWidth
      maxWidth="sm"
      footerComponent={
        <>
          <RegularButton color="success" size="sm" onClick={updateStock} disabled={loading}>
            Guardar
          </RegularButton>
        </>
      }
    >
      <GridContainer>
        <GridItem xs={12} style={{ marginBottom: '5px' }}>
          <TextField
            disabled
            fullWidth
            label="Almacén"
            value={model.WhsName}
            InputProps={{ readOnly: true }}
            InputLabelProps={{ shrink: true }}
          />
        </GridItem>
        <GridItem xs={12} style={{ marginBottom: '5px' }}>
          <TextField
            disabled
            fullWidth
            label="Stock"
            value={model.OnHand}
            InputProps={{ readOnly: true }}
            InputLabelProps={{ shrink: true }}
          />
        </GridItem>
        <GridItem xs={12} style={{ marginBottom: '5px' }}>
          <TextField
            disabled
            fullWidth
            label="Stock comprometido"
            value={model.IsCommited}
            InputProps={{ readOnly: true }}
            InputLabelProps={{ shrink: true }}
          />
        </GridItem>
        <GridItem xs={12}>
          <FormControl fullWidth margin="normal" size="small">
            <InputLabel>Bloqueado</InputLabel>
            <Select
              value={locked}
              inputProps={{ name: 'Locked' }}
              onChange={(e) => setLocked(e.target.value)}
            >
              <MenuItem value="Y">Si</MenuItem>
              <MenuItem value="N">No</MenuItem>
            </Select>
          </FormControl>
        </GridItem>
      </GridContainer>
    </ModalBase>
  );
}

export default EditStockModal;
